
import { OLMSApiService } from '@/shared/apis'
import { RootState } from '@/shared/store'
import { createAsyncThunk, EntityId } from '@reduxjs/toolkit'

export type OptimiseShiftPayload = {
  shiftId: EntityId // The Shift Id
  fromStopId?: EntityId
}

export const optimiseShift = createAsyncThunk<void, OptimiseShiftPayload, { state: RootState }>(
  'scenario/optimiseShift',
  async ({ shiftId, fromStopId = null }, { getState }) => {
    const state = getState()
    const currentScreen = state.userInterface.currentScreen
    const endpoint = currentScreen === 'planning' ? '/planning/optimiseShift' : '/runsheet/optimiseShift'

    await OLMSApiService.post<null>(endpoint, {
      shiftId,
      fromStopId,
    })
  },
)
